import React from "react";
import FormattedDate from "./FormattedDate";
import WeatherTemperature from "./WeatherTemperature";
import "./WeatherInfo.css";

export default function WeatherInfo(props) {
  const roundedWindSpeed = Math.round(props.data.wind);

  return (
    <article className="WeatherInfo p-3">
      <section>
        <div className="row p-3">
          <section className="justify-center col-12">
            <article>
              <h1>{props.data.city}</h1>
              <div class="current-city-temperature">
                <div className="current-city-detail">
                  <WeatherTemperature fahrenheit={props.data.temperature} />
                </div>
              </div>
            </article>
            <div className="current-city-detail current-information p-2">
              <div className="current-day">
                <FormattedDate date={props.data.date} />
              </div>
              <div class="d-flex">
                <div className="current-description">
                  {props.data.description}
                </div>
                <span className="current-humidity">
                  <i class="fa-solid fa-droplet"></i>
                  {"° "}
                  <span className="percentage">{props.data.humidity}% </span>
                </span>
                <span className="current-wind">
                  <i class="fa-solid fa-wind"></i>{" "}
                  <span className="wind-mph">{roundedWindSpeed}mph</span>
                </span>
              </div>
            </div>
          </section>
        </div>
      </section>
    </article>
  );
}
